module.exports = __webpack_public_path__ + "static/media/img_landing.dd102af6.png";